import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: ${({ theme }) => theme.overlay};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

export const ModalContent = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.surfaceElevated};
  border-radius: 8px;
  box-shadow: 0 4px 20px ${({ theme }) => theme.shadowColor};
  width: 100%;
  max-width: 600px;
  max-height: 90vh;
  overflow: auto;
  margin: 20px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  color: ${({ theme }) => theme.textSubtle};
  cursor: pointer;
  padding: 4px 8px;
  transition: color 0.2s;

  &:hover:not(:disabled) {
    color: ${({ theme }) => theme.modalCloseHover};
  }

  &:disabled {
    color: ${({ theme }) => theme.modalBorderColor};
    cursor: not-allowed;
  }
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  padding-right: 48px;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid ${({ theme }) => theme.divider};
`;

export const ModalBody = styled.div`
  padding: 20px 24px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid ${({ theme }) => theme.divider};
`;

export const TextAreaSimple = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 12px;
  border: 1px solid ${({ theme }) => theme.modalBorderColor};
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primary};
  }

  &::placeholder {
    color: ${({ theme }) => theme.modalTextLight};
  }
`;
